
export const HeadingOne = ({ children }) => {
    return (
        <h3 className="fw-bold mb-0" style={{ color: "var(--reverse-color)" }}>{children}</h3>
    )
}

